// Composes a readable day entry ("question\nanswer" blocks) from the
// responses given during a session, optionally restricted to specific questions.
export const composeActivityEntry = (
  rootStore: any,
  sessionId: string,
  questionIds?: string[],
): string => {
  const responses = rootStore?.responses?.responses?.filter((r: any) =>
    r.sessionId === sessionId && (!questionIds || questionIds.includes(r.questionId))
  ) || [];
  const parts = responses.map((r: any) => {
    const question = rootStore?.question?.getQuestion(r.questionId);
    const wording = question?.question || '';
    let answerText = r.freeText || '';
    if (!answerText && r.answers?.length) {
      answerText = r.answers
        .map((a: any) => question?.answers?.find((qa: any) => qa._id === a.id)?.wording || '')
        .filter(Boolean)
        .join(', ');
    }
    if (!answerText && r.value !== undefined && r.value !== null) {
      answerText = String(r.value);
    }
    if (!answerText) {
      return '';
    }
    return wording ? `${wording}\n${answerText}` : answerText;
  }).filter(Boolean);
  return parts.join('\n\n');
};
